module.exports = __webpack_public_path__ + "img/West-Mermis-Case-Study-600px.3458e962.png";